import { XIcon } from "@heroicons/react/solid";

const ToggleFlagModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading = false,
  accountNumber,
  currentFlagStatus,
  adminReason,
  bankCode,
  bankName,
  existingAdminReason,
  onAdminReasonChange
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-bold uppercase text-gray-900">
            Flag Account
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
            disabled={loading}
          >
            <XIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="p-4">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2 font-medium">
                Account Number
              </label>
              <input
                type="text"
                value={accountNumber}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-2 font-medium">
                Bank Code
              </label>
              <input
                type="text"
                value={bankCode}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-gray-700 mb-2 font-medium">
                Bank Name
              </label>
              <input
                type="text"
                value={bankName}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>

            {existingAdminReason && (
              <div className="mb-4">
                <label className="block text-gray-700 mb-2 font-medium">
                  Previous Flag Reason
                </label>
                <textarea
                  value={existingAdminReason}
                  readOnly
                  rows={2}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                />
              </div>
            )}

            <div className="mb-4">
              <label className="block text-gray-700 mb-2 font-medium" htmlFor="adminReason">
                Reason for Flagging *
              </label>
              <textarea
                id="adminReason"
                value={adminReason}
                onChange={(e) => onAdminReasonChange(e.target.value)}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter reason for flagging this account..."
                required
              />
            </div>

            <div className="flex justify-end">
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="mr-3 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50"
              >
                {loading ? "Processing..." : "Flag Account"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ToggleFlagModal;